<div class="tag-data-container">
    <button class="btn btn-outline-black"(click)="save()">{{'Approve'| i18n}}  <div class="loader"  *ngIf="loadingFlag"></div></button>
   

</div>